var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "48px",
    viewBox: "0 0 72 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/Tender_MC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tender_MC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 0,
    y: 0,
    width: 72,
    height: 48,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "mc_vrt_rgb_pos",
    transform: "translate(6.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#CE5052",
    points: "22.2526957 33.936 38.6874783 33.936 38.6874783 4.40243478 22.2526957 4.40243478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2961739,19.1692174 C23.2961739,13.1775652 26.1015652,7.84173913 30.470087,4.40243478 C27.2754783,1.88713043 23.244,0.386608696 18.8624348,0.386608696 C8.49026087,0.386608696 0.0813913043,8.796 0.0813913043,19.1692174 C0.0813913043,29.5424348 8.49026087,37.9518261 18.8624348,37.9518261 C23.244,37.9518261 27.2754783,36.4513043 30.470087,33.936 C26.1015652,30.4966957 23.2961739,25.1608696 23.2961739,19.1692174",
    id: "Fill-3",
    fill: "#FB6264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2723478,30.8081739 L60.2723478,30.0787826 L60.0824348,30.0787826 L59.8633043,30.5806957 L59.6441739,30.0787826 L59.4537391,30.0787826 L59.4537391,30.8081739 L59.5883478,30.8081739 L59.5883478,30.2582609 L59.7933913,30.732 L59.9326957,30.732 L60.1382609,30.2572174 L60.1382609,30.8081739 L60.2723478,30.8081739 Z M59.0671304,30.8081739 L59.0671304,30.2034783 L59.3107826,30.2034783 L59.3107826,30.0803478 L58.689913,30.0803478 L58.689913,30.2034783 L58.9335652,30.2034783 L58.9335652,30.8081739 L59.0671304,30.8081739 Z M60.8587826,19.1692174 C60.8587826,29.5424348 52.4504348,37.9518261 42.0777391,37.9518261 C37.6961739,37.9518261 33.6652174,36.4513043 30.470087,33.936 C34.8386087,30.4966957 37.644,25.1608696 37.644,19.1692174 C37.644,13.1775652 34.8386087,7.84173913 30.470087,4.40243478 C33.6652174,1.88713043 37.6961739,0.386608696 42.0777391,0.386608696 C52.4504348,0.386608696 60.8587826,8.796 60.8587826,19.1692174 Z",
    id: "Fill-4",
    fill: "#FCA468"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "assets/media/mastercard.8d9541df66d5feb6dd49b8728200a376.svg";
export { ForwardRef as ReactComponent };